<template>
  <div class="player text-left" ref="main" v-resize="handleResize">
    <div class="items-center flex player__top">
      <div class="flex-grow overflow-hidden relative title-wrapper">
        <my-title></my-title>
      </div>
      <div class="flex-none flex buttons buttons--top-actions">
        <minimize-button></minimize-button>
        <close-button></close-button>
      </div>
    </div>
    <div class="flex flex-wrap l:flex-no-wrap" style="padding-bottom: 21px;">
      <div class="flex-100 l:flex-none">
        <ul class="flex flex-wrap buttons buttons--actions justify-between">
          <li>
            <chapter-previous class></chapter-previous>
          </li>
          <li>
            <step-backward class></step-backward>
          </li>
          <li>
            <play-button class="play-button--fixed"></play-button>
          </li>
          <li>
            <step-forward class></step-forward>
          </li>
          <li>
            <chapter-next class></chapter-next>
          </li>
          <li class="text-white text-xs">
            <speed-counter></speed-counter>
          </li>
        </ul>
      </div>
      <div class="flex-1 items-center flex progress-wrapper">
        <timer-current class="text-xs"></timer-current>
        <progress-bar class="progress-bar--actions"></progress-bar>
        <timer-duration class="text-xs"></timer-duration>
      </div>
    </div>
    <div>
      <extended-block>
        <div class="flex tabs">
          <tab-trigger tab="chapters">
            <icon type="chapter"></icon>
          </tab-trigger>
          <tab-trigger tab="playlist" v-if="!isIe()">
            <icon type="playlist"></icon>
          </tab-trigger>
          <tab-trigger tab="subscriptions">
            <icon type="subscriptions"></icon>
          </tab-trigger>
          <!-- <tab-trigger tab="share">
                  <icon type="share"></icon>
          </tab-trigger>-->
        </div>

        <div class="relative overflow-hidden outline-none">
          <tab name="chapters">
            <tab-chapters></tab-chapters>
          </tab>
          <tab name="playlist" v-if="!isIe()">
            <tab-playlist></tab-playlist>
          </tab>
          <tab name="subscriptions" v-if="!isIe()">
            <tab-subscriptions></tab-subscriptions>
          </tab>
          <!-- <tab name="share">
                  <tab-share></tab-share>
          </tab>-->
        </div>
        <!-- <error></error> -->
      </extended-block>
    </div>
  </div>
</template>

<script>
import resize from 'vue-resize-directive';
import select from '@/store/selectors';
import { isIe } from '@/utils/detect';
import { PLAYER_RESIZED, PLAYER_MOUNTED } from '@/utils/messages';

import {
  PlayButton,
  CloseButton,
  MinimizeButton,
  MyTitle,
  ExtendedBlock,
  ChapterNext,
  ChapterPrevious,
  StepBackward,
  StepForward,
  TimerDuration,
  TimerCurrent,
  ProgressBar,
  TabTrigger,
  Tab,
  TabChapters,
  TabPlaylist,
  TabSubscriptions,
  SpeedCounter,
} from '@/components';

export default {
  directives: {
    resize,
  },
  components: {
    PlayButton,
    ExtendedBlock,
    CloseButton,
    MinimizeButton,
    MyTitle,
    ChapterNext,
    ChapterPrevious,
    StepBackward,
    StepForward,
    TimerDuration,
    TimerCurrent,
    ProgressBar,
    TabTrigger,
    Tab,
    TabChapters,
    TabPlaylist,
    TabSubscriptions,
    SpeedCounter,
  },
  props: {
    msg: String,
  },
  data() {
    return {
      ...this.mapState({
        background: select.theme.brandDarkest,
        font: select.theme.fontRegular,
        fonts: select.theme.fonts,
        isExtended: select.components.extendedBlock,
        playerId: select.playerId,
      }),
    };
  },
  methods: {
    handleResize(e) {
      window.parent.postMessage(
        {
          type: PLAYER_RESIZED,
          data: {
            playerId: this.playerId,
            height: `${e.offsetHeight}px`,
          },
        },
        '*',
      );
    },
    isIe: () => isIe,
  },
  mounted() {
    window.parent.postMessage(
      {
        type: PLAYER_MOUNTED,
        data: {
          playerId: this.playerId,
        },
      },
      '*',
    );
  },
};
</script>

<style scoped lang="scss">
@import "~@/assets/scss/media.scss";

.player {
  background-color: #333;
  margin: 0 auto;
  padding: 0 15px;
  position: relative;
}

@include only-desktop {
  .player {
    padding: 0 20px;
  }
}

.title-wrapper {
  height: 16px;
  position: relative;

  &::after {
    content: "";
    position: absolute;
    height: 100%;
    top: 0;
    width: 15px;
    z-index: 1;
  }

  &::after {
    background: linear-gradient(
      to left,
      rgba(51, 51, 51, 1),
      rgba(51, 51, 51, 0)
    );
    right: 0;
  }
}

.buttons {
  align-items: center;
  display: flex;
  line-height: 0;
  list-style: none;

  > *:empty {
    display: none;
  }
}

.buttons--top-actions {
  > *:not(:last-child) {
    margin-right: 15px;
  }
}

.buttons--actions {
  @include only-desktop {
    > * {
      margin-right: 33px;
    }
  }
}

.player__top {
  height: 49px;
  padding-top: 3px;
  transition: margin-left 0.3s ease-in-out;
}

.player__top--is-extended {
  margin-left: -20px;
}

.progress-bar--actions {
  margin: 0 8px;
}

.play-button--fixed {
  width: 21px;
}

@include only-mobile {
  .progress-wrapper {
    margin-top: 15px;
  }
}

.tabs {
  margin: 20px 0 15px;

  @include only-desktop {
    margin-top: 25px;
  }

  > * {
    margin-right: 33px;
  }

  > *:last-child {
    margin-right: 0;
  }
}
</style>
